import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AuthService, HackathonUser } from '../../_services/auth.service';
import { DEFAULT_PFP, MatrixService } from '../../_services/matrix.service';
import { SystemService } from '../../_services/system.service';

@Component({
  selector: 'app-new-message',
  templateUrl: './new-message.component.html',
  styleUrls: ['./new-message.component.scss']
})
export class NewMessageComponent implements OnInit {
	@ViewChild('searchbar') searchbar : any;
	@ViewChild('newmessage') newmessage : any;
    @Input() incomingSearch? : string
	
	newMessage : string
	profiles : HackathonUser[]
	selectedProfile? : HackathonUser
	searchFor? : string

	loading = true;

	get canSend(){
		return this.selectedProfile && this.newMessage && this.newMessage.length > 0;
	}

constructor(
		public modalC : ModalController,
		public auth : AuthService,
		private matrix : MatrixService,
		private nav : NavController,
		private system : SystemService ){}

	ngOnInit(): void {
        if (this.incomingSearch){ 
            this.loading = true
            this.searchFor = this.incomingSearch;
            this.auth.searchProfile(this.searchFor).then((res)=>{
                if (JSON.stringify(this.profiles) != JSON.stringify(res)) this.profiles = res
                this.loading = false;
            })
        }
	}

	ionViewDidEnter(): void {
		// setTimeout(() => {
        //     this.searchbar?.setFocus()
        // }, 500);

		if (this.auth.user && !this.incomingSearch){
			this.auth.searchProfile().then((res)=>{
				this.profiles = res.filter((profile : HackathonUser) => profile.Id != this.auth.user.Id);
                this.loading = false;
			})
		}
	}

	onSendMessage(ev: SubmitEvent) {
		ev.preventDefault();
		// console.log(this.newMessage);
		
		// if(this.roomID && this.message)
		// this.matrix.sendMessage(this.roomID, this.message).then(() => {
		// 	this.message = undefined;
		// }).catch((err) => {
		// });
	}
	
	doSearch(e : any){
		let query = e.target.value
		if (query && query != ''){
			this.loading = true;
            this.auth.searchProfile(query).then((res)=>{
                // console.log(">",res);
                this.searchFor = query
                if (JSON.stringify(this.profiles) != JSON.stringify(res)) this.profiles = res.filter((profile : HackathonUser) => profile.Id != this.auth.user.Id);
                this.loading = false;
            })
        }
        else this.auth.searchProfile().then((res)=>{
            this.profiles = res.filter((profile : HackathonUser) => profile.Id != this.auth.user.Id);
        })
    }
	
	selectProfile(profile : HackathonUser){
		// console.log(profile);
		// let roomName = this.matrix.namesToRoom(this.auth.user.Id, profile.Id)
		// console.log(profile.id, this.auth.user.Id, roomName);
		// console.log(this.matrix.rooms);
		// this.matrix.checkRoomExists(roomName).then((res)=>{
		// 	// console.log(res);
		// })
		// let exists = this.matrix.rooms.filter((room) => { return room.name === roomName })

		// if (exists.length > 0) {
		// 	this.modalC.dismiss();
		// 	this.nav.navigateForward(['/app', 'tabs', 'chat', 'room', this.matrix.sliceRoomId(exists[0].roomId)])
		// }
		// else {
			this.selectedProfile = profile;
			setTimeout(()=>{
				document.getElementById('message')?.focus();
			}, 500)
		// }
	}

	reselect(){
		this.selectedProfile = undefined;
		setTimeout(() => {
			this.searchbar?.setFocus()
		}, 1000);

	}

	sendMessage(){
		this.matrix.createRoom(this.selectedProfile.uuid, this.newMessage).then((roomId) => {
			// console.log(roomId);
			this.modalC.dismiss(roomId)
			this.matrix.emit('refresh-rooms')
		}, err => {
			// console.log(err);
			this.system.showToast({ header: err, color: 'warning'})
			this.matrix.emit('refresh-rooms')
			this.modalC.dismiss()
        })
	}

    onError(e: any, name : string) {
        e.target.src = this.matrix.letterPFP(name)
        // DEFAULT_PFP
    }
}
